import type { FC } from 'react';

import type { GCLicenseConfig } from 'config/types';

import type { GetLicenseProps } from './types';

const GCLicense: FC<GetLicenseProps<GCLicenseConfig>> = ({ id }) => {
  if (!id) {
    return null;
  }

  return import.meta.env.PROD ? (
    <a
      aria-label="Gaming Curacao: Click to Validate"
      href={`https://licensing.gaming-curacao.com/validator/?lh=${id}`}
      rel="noreferrer noopener"
      target="_blank"
    >
      <img
        alt="Gaming Curacao: Click to Validate"
        height="50"
        src="https://licensing.gaming-curacao.com/validator/images/Gaming-Curacao-ClickToVerify.png"
        width="150"
      />
    </a>
  ) : (
    <iframe
      height="50"
      src={`https://licensing.gaming-curacao.com/validator/?lh=${id}&template=tseal`}
      style={{ border: 'none' }}
      width="120"
      title="License Validation"
    />
  );
};

export default GCLicense;
